export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    field: 'erpOrderNo',
    title: 'ERP订单号',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'custName',
    title: '客户',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'lineStatus',
    title: '行状态',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'lineStatus',
    },
  },
  {
    field: 'uploadStatus',
    title: '上传信息状态',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'uploadStatus',
    },
  },
  {
    field: 'uploadTime',
    title: '上传处理时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'errorMsg',
    title: '错误信息',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'creationTime',
    title: '创建时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'updatedTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
